const Auth = ({ children }) => children;

export default Auth;
